export default {
    filters: {
        /**
         * 
         * 12 June 1979 => 1979-06-12
         *
         * @param {String} format YYYY-MM-DD
         */        
        formatDate: function (value, format) {
            if (!(value && format)) return value;
            return moment(value).format(format);
        },
        /**
         * 
         * 12345 => $12,345.00
         *
         * @param {String} symbol
         * @param {Number} decimals Decimal places
         * @param {Object} options
         */        
        currency: function (value, symbol, decimals, options) {
            var thousandsSeparator, symbolOnLeft, spaceBetweenAmountAndSymbol
            var digitsRE = /(\d{3})(?=\d)/g
            options = options || {}
            value = parseFloat(value)
            if (!isFinite(value) || (!value && value !== 0)) return ''
            symbol = symbol != null ? symbol : '$'
            decimals = decimals != null ? decimals : 2
            thousandsSeparator = options.thousandsSeparator != null ? options.thousandsSeparator : ','
            symbolOnLeft = options.symbolOnLeft != null ? options.symbolOnLeft : true
            spaceBetweenAmountAndSymbol = options.spaceBetweenAmountAndSymbol != null ? options.spaceBetweenAmountAndSymbol : false
            var stringified = Math.abs(value).toFixed(decimals)
            stringified = options.decimalSeparator
              ? stringified.replace('.', options.decimalSeparator)
              : stringified
            var _int = decimals
              ? stringified.slice(0, -1 - decimals)
              : stringified
            var i = _int.length % 3
            var head = i > 0
              ? (_int.slice(0, i) + (_int.length > 3 ? thousandsSeparator : ''))
              : ''
            var _float = decimals
              ? stringified.slice(-1 - decimals)
              : ''
            symbol = spaceBetweenAmountAndSymbol
              ? (symbolOnLeft ? symbol + ' ' : ' ' + symbol)
              : symbol
            symbol = symbolOnLeft
              ? symbol + head +
                _int.slice(i).replace(digitsRE, '$1' + thousandsSeparator) + _float
              : head +
                _int.slice(i).replace(digitsRE, '$1' + thousandsSeparator) + _float + symbol
            var sign = value < 0 ? '-' : ''
            return sign + symbol            
        },
        /**
         *  Converts a string into Capitalize
         * 
         * 'abc' => 'Abc'
         */        
        capitalize: function (value) {
            if (!value && value !== 0) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)            
        },
        /**
         * Converts a string to UPPERCASE
         * 
         * 'abc' => 'ABC'
         */        
        uppercase: function (value) {
            return (value || value === 0)
            ? value.toString().toUpperCase()
            : ''
        },
        /**
         * Converts a string to lowercase
         * 
         * 'AbC' => 'abc'
         */        
        lowercase: function (value) {
            return (value || value === 0)
            ? value.toString().toLowerCase()
            : ''
        },
        /**
         *  Truncate at the given || default length
         *
         * 'lorem ipsum dolor' => 'lorem ipsum dol...'
         */        
        truncate: function (value, length) {
            length = length || 15
            if( !value || typeof value !== 'string' ) return ''
            if( value.length <= length) return value
            return value.substring(0, length) + '...'
        }
    },    
    methods: {
        $setDateNull: function(obj) {
            if(obj && obj.doDate) {
                if(_.isEmpty(_.compact(obj.doDate))) obj.doDate = null;
            }
            return obj;
        },
        $setItemIds: function(event) {
            let checkBoxes = $(event.target).closest('table').find('td input[type="checkbox"]');
            if(event.target.value === 'all') { // Select all
                checkBoxes.prop('checked', $(event.target).prop('checked'));
            } else {
                let allCheckBox = $(event.target).closest('table').find('th input[type="checkbox"]');
                allCheckBox.prop('checked', !checkBoxes.not(':checked').length);
            }
            // Set Selected Items
            let selectedItemIds = []
            _.each(checkBoxes, function(ele){
                if($(ele).prop('checked')){
                    selectedItemIds.push($(ele).val());
                }
            });

            return selectedItemIds;
        },
        $sortByIndicator: function(filterData, field, isDelete = false, event) {
            return new Promise((resolve, reject) => {
                let self = this;
                let indexOf = _.indexOf(filterData, '-' + field) + 1  || _.indexOf(filterData, '+' + field) + 1;
                let sign = '+';
                let $ele = '';
                if($(event.target).hasClass('sortable')) {
                    $ele = $(event.target);
                } else {
                    $ele = $(event.target).parent();
                }   
                $ele.removeClass('footable-sorted')
                .addClass('footable-sorted-desc')
                .addClass(field + '-sorted');
                if(indexOf === 0) {
                    filterData.push('+' + field); 
                } else if(isDelete) {
                    let deleteClass = field + '-sorted';
                    let key = _.findIndex(filterData, function(o) {
                        return o.substring(1) == field; 
                    });
                    filterData.splice(key, 1);
                    $('.' + deleteClass)
                    .removeClass('footable-sorted')
                    .removeClass('footable-sorted-desc')
                    .removeClass(deleteClass);
                } else {
                    sign = (filterData[(indexOf - 1)].substring(0, 1) === '+' ? '-':'+');
                    filterData[(indexOf - 1)] = sign + filterData[(indexOf - 1)].substr(1);
                    if(sign === '-') $(event.target).removeClass("footable-sorted-desc").addClass("footable-sorted"); 
                }
                resolve(filterData);
            });
        },
        $isThisDay: function(datetime) {
            return moment(datetime).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD');
        },
        $hasRole: function(role_name) {
            let role = _.findLast(this.$parent.user.roles, function(o) { return o.name === role_name; });
            return !_.isUndefined(role);
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins.js